module.exports = __webpack_public_path__ + "img/C Sharp.6eed9079.png";